'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { ListItemBaseLi, ListItemBaseInnerWrapper } from './ListItemBase.js';

const StyledListItemBaseLi = styled(ListItemBaseLi).withConfig({
  componentId: "sc-1flxrst-0"
})(["", ";", ";"], ({
  py
}) => py && css(["", " ", ""], spaceProp(py, 'padding-top'), spaceProp(py, 'padding-bottom')), ({
  px
}) => px && css(["", " ", ""], spaceProp(px, 'padding-left'), spaceProp(px, 'padding-right')));
const ListItem = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      prefixAdornment,
      suffixAdornment,
      className,
      onClick,
      testId = 'listItem'
    } = _a,
    rest = __rest(_a, ["children", "prefixAdornment", "suffixAdornment", "className", "onClick", "testId"]);
  return jsx(StyledListItemBaseLi, Object.assign({
    className: className,
    "data-test-id": testId,
    onClick: onClick
  }, rest, {
    children: jsx(ListItemBaseInnerWrapper, {
      prefixAdornment: prefixAdornment,
      suffixAdornment: suffixAdornment,
      children: children
    })
  }));
}, {
  name: 'ListItem'
});

export { ListItem };
//# sourceMappingURL=ListItem.js.map
